import { render, staticRenderFns } from "./RuleHistorical.vue?vue&type=template&id=94809568&"
import script from "./RuleHistorical.vue?vue&type=script&lang=js&"
export * from "./RuleHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports